import { useRouter } from "next/router";
import { type Locale } from "~/features/i18n/utils";

export const useLocale = () => {
  const router = useRouter();
  const locale = router.locale as Locale;
  return locale;
};
